var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('PageLoader'),_c('TheHeader'),_c('router-view',{key:_vm.$route.path,staticClass:"content"}),_c('TheFooter',{staticClass:"footer"}),_c('button',{staticClass:"go-to-top",on:{"click":_vm.goToTop}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-arrow-up")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }